import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import {
  antdMessageError,
  errorHandler,
} from "../../helpers/Utils";
import { DEFAULT_IMUM_RULES_PER_PAGE } from "../../helpers/default";
import moment from "moment";

export const getImumRules = (page, filterParams) => async (dispatch) => {
  try {
    dispatch({ type: "ONLY_LOADING_CUSTOM" });
    const func_api_call_time = Date.now();

    const { data } = await Axios.get(
      `/api/v1/${window.identifier}/imum_rules?page=${page}&per_page=${DEFAULT_IMUM_RULES_PER_PAGE}${filterParams}`
    );
    dispatch(
      setValue(
        {
          type: "GET_CUSTOMS",
          payload: {
            ...data,
            data: data.data,
            current: "imum_rules",
            totals: data.totals || 0,
            // show_data: {
            //   last_sync: data.last_sync ? prettyDateFormat(data.last_sync) : "",
            //   progress: data.progress,
            // },
          },
        },
        func_api_call_time
      )
    );
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const putItemRule = (params) => async (dispatch) => {
  const key = "putItemRule";
  try {
    antdAsyncMessageLoading({ key });
    const imum_rule = { ...params };
    delete imum_rule.current_brands;
    delete imum_rule.current_exclude_brands;
    delete imum_rule.current_products;
    delete imum_rule.current_exclude_products;
    delete imum_rule.current_categories;
    delete imum_rule.current_suppliers;
    delete imum_rule.current_tags;
    delete imum_rule.current_exclude_tags;

    const updating = params.id;

    const errorHandler = () => {
      let errors = {};
      if (!imum_rule.title) errors.title = "Cannot be empty";
      if (!imum_rule?.parameters?.let_prices)
        errors.let_prices = "Cannot be empty";
      if (!imum_rule.countries?.length) errors.countries = "Cannot be empty";
      if (!imum_rule.valid_from) errors.valid_from = "Cannot be empty";
      // if (imum_rule?.parameters?.ignore_the_prime_cost) {

      // }
      if (!imum_rule.schedule_days?.length)
        errors.schedule_days = "Cannot be empty";
      if (!imum_rule.schedule_time) errors.schedule_time = "Cannot be empty";
      return errors;
    };

    const errors = errorHandler();
    if (Object.keys(errors).length > 0) {
      antdAsyncMessageError({ key, text: "Valdidation errors" });
      return { success: false, errors };
    }
    if (
      !(
        typeof imum_rule.schedule_time == "string" &&
        imum_rule.schedule_time.length == 5
      )
    ) {
      imum_rule.schedule_time = moment(imum_rule.schedule_time).format("HH:mm");
    }

    if (
      !(
        typeof imum_rule.schedule_time_2 == "string" &&
        imum_rule.schedule_time_2.length == 5
      )
    ) {
      imum_rule.schedule_time_2 = moment(imum_rule.schedule_time_2).format(
        "HH:mm"
      );
    }

    const { data } = await Axios({
      url: `/api/v1/${window.identifier}/imum_rules/${
        updating ? updating : ""
      }`,
      data: { imum_rule },
      method: updating ? "PUT" : "POST",
    });

    antdAsyncMessageSuccess({ key });
    dispatch({
      type: updating ? "UPDATE_CUSTOM" : "POST_CUSTOM",
      payload: data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key, text: err?.message });
    const rawErrors = err?.response?.data?.errors || {};
    const normalizedErrors = Object.entries(rawErrors).reduce(
      (acc, [field, messages]) => {
        acc[field] = Array.isArray(messages) ? messages.join(", ") : messages;
        return acc;
      },
      {}
    );
    return {
      success: false,
      errors: normalizedErrors,
    };
  }
};

export const duplicateImumRule = (item_rule_id) => async (dispatch) => {
  const key = "duplicateImumRule";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(
      `/api/v1/${window.identifier}/imum_rules/${item_rule_id}/duplicate`
    );
    // if (!data.success) throw new Error(data.message);
    console.log({ data });
    antdAsyncMessageSuccess({ key });
    dispatch({
      type: "POST_CUSTOM",
      payload: data,
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    antdAsyncMessageError({ key });
    return { success: false };
  }
};

export const removeImumRule = (item_rule_id) => async (dispatch) => {
  const key = "removeImumRule";
  try {
    antdAsyncMessageLoading({ key });
    await Axios.delete(
      `/api/v1/${window.identifier}/imum_rules/${item_rule_id}`
    );
    antdAsyncMessageSuccess({ key });
    dispatch({
      type: "REMOVE_CUSTOM",
      payload: item_rule_id,
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    antdAsyncMessageError({ key });
    return { success: false };
  }
};

const setValue =
  (val, time = Date.now()) =>
  (dispatch, getState) => {
    const api_call_time = getState().custom.api_call_time;
    console.log("1");
    if (api_call_time > time) return console.log("%cSkipina", "color: red;");
    console.log("3");
    dispatch(val);
  };
